import { render, staticRenderFns } from "./MapItem.vue?vue&type=template&id=e1654928&"
import script from "./MapItem.vue?vue&type=script&lang=js&"
export * from "./MapItem.vue?vue&type=script&lang=js&"
import style0 from "./MapItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports